import Home from '@/views/ch/1-Home.vue'

export const chRoutes = [
    {
        path: '',
        name: 'Home',
        component: Home,
    },
    {
        path: 'statistics',
        name: 'Statistics',
        component: () => import('@/views/ch/2-Statistics.vue'),
    },
    {
        path: 'activities',
        name: 'Activities',
        component: () => import('@/views/ch/3-Activities.vue'),
    },
    {
        path: 'supply-chain',
        name: 'SupplyChain',
        component: () => import('@/views/ch/4-SupplyChain.vue'),
        children: [
            {
                path: 'intro',
                name: 'SupplyChainIntro',
                component: () => import('@/views/ch/4-1-Intro.vue'),
            },
            {
                path: 'join',
                name: 'SupplyChainJoin',
                component: () => import('@/views/ch/4-2-Join.vue'),
            },
            {
                path: 'companies/:type/:companyId',
                name: 'SupplyChainCompanies',
                component: () => import('@/views/ch/4-1-1-Companies.vue'),
            },
            {
                path: 'companies-trashcar',
                name: 'SupplyChainCompaniesTrashcar',
                component: () =>
                    import('@/views/ch/4-1-2-CompaniesTrashcar.vue'),
            },
        ],
    },
    {
        path: 'cycle-badge',
        name: 'CycleBadge',
        component: () => import('@/views/ch/5-CycleBadge.vue'),
        children: [
            {
                path: 'intro',
                name: 'CycleBadgeIntro',
                component: () => import('@/views/ch/5-1-Intro.vue'),
            },
            {
                path: 'progress',
                name: 'CycleBadgeProgress',
                component: () => import('@/views/ch/5-2-Progress.vue'),
            },
            {
                path: 'case',
                name: 'CycleBadgeCase',
                component: () => import('@/views/ch/5-3-Case.vue'),
                children: [
                    {
                        path: 'list',
                        name: 'CycleBadgeCaseList',
                        component: () => import('@/views/ch/5-3-1-List.vue'),
                    },
                    {
                        path: 'detail/:companyId',
                        name: 'CycleBadgeCaseDetail',
                        component: () => import('@/views/ch/5-3-2-Detail.vue'),
                    },
                ],
            },
        ],
    },
    {
        path: 'information',
        name: 'Information',
        component: () => import('@/views/ch/6-Information.vue'),
        children: [
            {
                path: 'document',
                name: 'InformationDocument',
                component: () => import('@/views/ch/6-1-Document.vue'),
            },
            {
                path: 'image',
                name: 'InformationImage',
                component: () => import('@/views/ch/6-2-Image.vue'),
            },
            {
                path: 'video',
                name: 'InformationVideo',
                component: () => import('@/views/ch/6-3-Video.vue'),
            },
        ],
    },
    {
        path: 'sitemap',
        name: 'Sitemap',
        component: () => import('@/views/ch/7-Sitemap.vue'),
    },
]
